/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import SelectTips from '../../../../core/SelectTips';
import {
  ChoiceBoxController,
  ToggleSwitchController,
  InputLineController,
} from '../../../controllers/Base';

const GeneralControllers = ({
  handle,
  config,
  extend,
  selectedLine,
  setExtend,
  selectedFunction,
}) => (
  <>
    <ControllersGroup
      title="Opções Gerais"
      id="general"
      extend={extend}
      setExtend={setExtend}
    >
      <ChoiceBoxController
        label="Fórmula"
        handle={handle}
        kWord="TotalFunctionControl"
        options={[
          { value: 'avg', label: 'Média dos valores', id: 'totalsAvg' },
          { value: 'sum', label: 'Soma dos valores', id: 'totalsSum' },
        ]}
        configValue={
          config?.TotalFunctionControl || (selectedFunction?.value === 'mean' ? 'avg' : 'sum')
        }
        fullWidth
        disabled={!selectedLine}
        text="Necessita da variável de linha"
      />
      <ToggleSwitchController
        label="Mínimo considerável"
        handle={handle}
        kWord="MinValueControl2"
        configValue={config?.MinValueControl?.checked}
        firstOption="Automático"
        secondOption="Manual"
        secondColor="secondary"
        disabled={!selectedLine}
        text="Necessita da variável de linha"
      />
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          width: 'calc(50% - 5px)',
        }}
      >
        <InputLineController
          isNumber
          precision={2}
          label=""
          handle={handle}
          kWord="MinValue"
          configValue={config?.MinValueControl?.value}
          disabled={!selectedLine || config?.MinValueControl?.checked}
          text="Necessita da variável de linha"
          fullWidth
        />
        <SelectTips
          style={{
            position: 'absolute',
            right: '0',
            top: '0',
          }}
          description="O valor mínimo a ser considerado no cálculo da fórmula"
        />
      </div>
      <ToggleSwitchController
        label="Máximo considerável"
        handle={handle}
        kWord="MaxValueControl2"
        configValue={config?.MaxValueControl?.checked}
        firstOption="Automático"
        secondOption="Manual"
        secondColor="secondary"
        disabled={!selectedLine}
        text="Necessita da variável de linha"
      />
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          width: 'calc(50% - 5px)',
        }}
      >
        <InputLineController
          isNumber
          precision={2}
          label=""
          handle={handle}
          kWord="MaxValue"
          configValue={config?.MaxValueControl?.value}
          disabled={!selectedLine || config?.MaxValueControl?.checked}
          text="Necessita da variável de linha"
          fullWidth
        />
        <SelectTips
          style={{
            position: 'absolute',
            right: '0',
            top: '0',
          }}
          description="O valor máximo a ser considerado no cálculo da fórmula"
        />
      </div>
      <ChoiceBoxController
        label="Formato"
        handle={handle}
        kWord="DataAbsoluteFormat"
        configValue={config?.DataAbsoluteFormat}
        options={[
          { label: 'Número', value: 'number', id: 'number' },
          { label: 'Duração', value: 'duration', id: 'duration' },
        ]}
        fullWidth
      />
      {config?.DataAbsoluteFormat === 'duration' && (
        <ChoiceBoxController
          label="Unidade original"
          handle={handle}
          kWord="DurationUnit"
          configValue={config?.DurationUnit}
          options={[
            { label: 'Dias', value: 'days', id: 'days' },
            { label: 'Horas', value: 'hours', id: 'hours' },
            { label: 'Minutos', value: 'minutes', id: 'minutes' },
            { label: 'Segundos', value: 'seconds', id: 'seconds' },
          ]}
          fullWidth
        />
      )}
    </ControllersGroup>
  </>
);

GeneralControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  selectedLine: PropTypes.shape({}),
  setExtend: PropTypes.func,
  selectedFunction: PropTypes.objectOf(PropTypes.any),
};

export default GeneralControllers;
